<template>
    <div class="fff">
        <div class="timeAll_w">
            <el-date-picker v-model="value1" class="timeAll" type="daterange" @change="getlist" range-separator="-"
                start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
            <el-dropdown @command="handleCommand" class="timeDow">
                <span class="el-dropdown-link" :style="{ color: !isChecked ? '#606266' : '#00eec3' }">
                     {{  $t('Last days Days',{days:days})  }}<i class="el-icon-caret-bottom el-icon--right"
                        :style="{ color: !isChecked ? '#606266' : '#00eec3' }"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="7">{{$t('videos.num1')}}</el-dropdown-item>
                    <el-dropdown-item command="30">{{$t('videos.num2')}}</el-dropdown-item>
                    <el-dropdown-item command="60">{{$t('videos.num3')}}</el-dropdown-item>
                    <el-dropdown-item command="90">{{$t('videos.num4')}}</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
        <!-- <div class="photos_li">
    <div class="img">
      <iframe height="180" width="328" src="https://player.youku.com/embed/XNTE3ODAzMzUzMg==" frameborder="allowfullscreen"></iframe>
    </div>
    <div class="time">Apr 5, 2021 10:20 AM</div>
  </div>
  <div class="photos_li">
    <div class="img">
      <object data="https://www.runoob.com/try/demo_source/movie.mp4" height="180" width="328"></object>
    </div>
    <div class="time">Apr 5, 2021 10:20 AM</div>
  </div> -->
        <div class="photos" ref="imgbody">
            <div class="photos_li" v-for="(val, key) in list" :key="key">
                <div class="img">
                    <!-- <object :data="val.url" height="180" width="328"></object> -->
                    <video class="video-js" controls preload="auto" width="100%" height="100%"
                        :poster="val.imgsrc" data-setup="{}" muted>
                        <source :src="val.url" type="video/mp4" />
                    </video>
                </div>
                <div class="time">

                    {{ val.createtime }}
                    <img @click="download(val.url)" src="@/assets/img/download.png" />
                </div>
            </div>
            <div style="clear: both"></div>
        </div>
        <div class="noData" v-if="list.length <= 0 && status">{{$t('videos.no')}}</div>
        <div class="pagination" v-if="code > 0">
            <el-pagination @current-change="setPage" background :page-size="key.limit" layout="prev, pager, next"
                :total="code">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import { Video } from '@/api/user'
import {downloadFilePic } from '@/api/getUrlBase64';
export default {
    name: 'HelloWorld',
    data () {
        return {
            days: 90,
            key: {
                equipment_id: localStorage.getItem('systemId'),
                page: 1,
                limit: 9999,
                starttime: '',
                endtime: ''
            },
            code: 0,
            value1: '', // 获取时间
            list: [],
            msg: '',
            isChecked: false,
            status: false
        }
    },
    mounted () {
        console.log('视频0909');
        let imgw = 340
        this.$nextTick(() => {
            let hCount = (this.$refs.imgbody.clientWidth - 17) / imgw
            let imgh = 3
            this.key.limit = imgh * parseInt(hCount)
            this.handleCommand()
        })
        // window.addEventListener('resize', () => {
        //     this.$nextTick(() => {
        //         let hCount = (this.$refs.imgbody.clientWidth - 17) / imgw
        //         let imgh = 3
        //         this.key.limit = imgh * parseInt(hCount)
        //         this.handleCommand()
        //     })
        // })
    },
    methods: {
        download (imgUrl) {
            downloadFilePic(imgUrl);
        },
        handleCommand (event) {
            let end = new Date()
            let start = new Date(new Date().setDate(end.getDate() - 90));
            if (event) {
                this.isChecked = true
                this.days = event
                start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * event)
            }
            this.value1 = [start, end]
            console.log(this.value1)
            this.getlist()
        },
        setPage (e) {
            this.key.page = e
            this.getlist()
        },
        getlist (a) {
            this.status = false
            this.key.starttime =
                this.value1[0].getFullYear() +
                '-' +
                (this.value1[0].getMonth() < 9 ? '0' : '') +
                (this.value1[0].getMonth() + 1) +
                '-' +
                (this.value1[0].getDate() < 10 ? '0' : '') +
                this.value1[0].getDate()
            this.key.endtime =
                this.value1[1].getFullYear() +
                '-' +
                (this.value1[1].getMonth() < 9 ? '0' : '') +
                (this.value1[1].getMonth() + 1) +
                '-' +
                (this.value1[1].getDate() < 10 ? '0' : '') +
                this.value1[1].getDate()
            console.log(this.key)
            if (a) {
                this.key.page = a
            }
            this.list = []
            Video(this.key).then((adj) => {
                this.list = adj.data.list
                this.code = adj.data.count
                if(this.list && this.list.length>0){
                this.list.map((item,index) =>{
                const videoEle = document.createElement("video"); // 以后video dom节点
                  videoEle.currentTime = 1; //      设置视频开始播放工夫（因为有些手机第一帧显示黑屏，所以这里选取视频的第一秒作为封面）
                  videoEle.addEventListener('canplay', function () { // 监听video的canplay事件
                  // 创立canvas元素 并设置canvas大小等于video节点的大小
                  const canvas = document.createElement('canvas');
                  const scale = 0.8; // 压缩系数
                  // canvas.width = videoEle.videoWidth * scale;
                  // canvas.height = videoEle.videoHeight * scale;
                  canvas.width = "320";
                  canvas.height = "180";
                  // canvas画图
                  canvas.getContext('2d').drawImage(videoEle, 0, 0, canvas.width, canvas.height);
                  
                  // 把canvas转成base64编码格局
                  const imgSrc = canvas.toDataURL('image/png');
                  // 创立img元素 插入到文档中
                  const img = document.createElement('img');
                  img.src = imgSrc;
                  img.style.position = 'absolute';
                  img.style.left = '0';
                  img.style.top = '0';
                  img.style.objectFit = 'cover';
                  videoEle.parentNode && videoEle.parentNode.appendChild(img);
                })
              })
            }
              this.status = true
            })
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fff {
    width: 97%;
    margin: 20px auto;
    background: #fff;
    border-radius: 12px;
    -webkit-box-shadow: 0 4px 12px -4px rgba(122, 138, 153, 0.2);
    box-shadow: 0 4px 12px -4px rgba(122, 138, 153, 0.2);
    overflow: hidden;
}

.photos {
    margin-right: 30px;
}

.photos_li {
    float: left;
    background: #fff;
    -webkit-box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.1);
    box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.1);
    border-radius: 15px;
    width: 320px;
    /* width: calc((100% / 3.5)); */
    height: 230px;
    position: relative;
    margin-left: 20px;
    margin-top: 20px;
    overflow: hidden;
}

.photos_li .img {
    width: 100%;
    height: 180px;
    overflow: hidden;
}

.photos_li .img img {
    width: 200px;
    height: 200px;
}

.photos_li .time {
    height: 50px;
    line-height: 50px;
    text-indent: 13px;
    font-size: 12px;
    color: #3f3f3f;
    overflow: hidden;
}

.photos_li .time img {
    height: 16px;
    width: 16px;
    float: right;
    margin: 17px 10px 0 0;
    cursor: pointer;
}

.video-js {
    width: 100%;
    height: 100%;
}

video {
    object-fit: cover !important;
}
/*video::-internal-media-controls-download-button {
    display:none;
}

video::-webkit-media-controls-enclosure {
    overflow:hidden;
}

video::-webkit-media-controls-panel {
    width: calc(100% + 30px); 
}*/
</style>



// WEBPACK FOOTER //
// src/components/Videos.vue